import type { TrendResultT } from '@mentimeter/visualizations';
import type { ScalesChoice, ScalesRange } from '../types';

export const getTrendsTestVotes = ({
  choices,
  range,
}: {
  choices: ScalesChoice[];
  range: ScalesRange;
}): TrendResultT[] => {
  const NUMBER_OF_SESSIONS = 5;
  const sessions = [];
  for (let i = 0; i < NUMBER_OF_SESSIONS; i++) {
    const current = i === NUMBER_OF_SESSIONS - 1;
    const session = {
      id: i,
      label: current ? 'Current ' : `Session ${i + 1}`,
      current,
      data: {
        session: i,
        participantCount: 5,
        responses: choices.map((option, index) => {
          const responses: number[] = [];
          if (range) {
            for (let j = range.min; j <= range.max; j++) {
              responses[j - range.min] = Math.floor(Math.random() * range.max);
            }
          }
          return {
            id: index,
            title: option.label,
            responses,
          };
        }),
      },
    };
    sessions.push(session);
  }
  return sessions;
};
